module.exports = ".banner {\r\n  padding: 25px;\r\n}\r\n\r\n.banner-small { width: 30vw; height: 30vh; }\r\n\r\n.banner-medium {\r\n  width: 650px;\r\n  height: 480px;\r\n}\r\n\r\n.banner-full { width: 90vw; height: 90vh; }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/banner-editor/stage/banner/banner.component.css
// module id = ./src/app/modules/banner-editor/stage/banner/banner.component.css
// module chunks = main